"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetsStartAConversation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative w-full overflow-hidden bg-page-background py-16 md:py-24 lg:py-32">
      {}
      <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <h1 className={`font-display text-4xl font-bold leading-tight tracking-tight text-foreground-page transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] sm:text-5xl md:text-6xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
          Let's Start a Conversation
        </h1>
      </div>
    </section>;
}